// Simple in-memory cache
const cache: Record<string, any> = {};

/**
 * Caches an item with the given key.
 * @param key - The key to store the item under.
 * @param value - The item to cache.
 */
export const cacheItem = (key: string, value: any): void => {
  cache[key] = value;
};

/**
 * Retrieves a cached item by its key.
 * @param key - The key of the item to retrieve.
 * @returns The cached item, or undefined if not found.
 */
export const getCachedItem = <T = any>(key: string): T | undefined => {
  return cache[key] as T | undefined;
};

/**
 * Clears a specific item from the cache by its key.
 * @param key - The key of the item to remove.
 */
export const clearCachedItem = (key: string): void => {
  if (key in cache) {
    delete cache[key];
  }
};

/**
 * Clears all items from the cache.
 */
export const clearAllCache = (): void => {
  for (const key in cache) {
    if (Object.prototype.hasOwnProperty.call(cache, key)) {
      delete cache[key];
    }
  }
};
